<template>
  <div class="pdf-container row" v-loading="loading">
    <div ref="pdfContainer" class="pdf-viewer"></div>
  </div>
</template>
    
<script>
import { PDFViewer } from 'web-pdf-viewer';
import api from '@/rest/questionQuery';

export default {
  name: 'Pdf',
  props: {
    goToPage: {
      required: false,
      type: Number,
      default: 1
    },
    go: {
      required: false,
      type: Boolean
    },
    link: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      pv: null,
      pdfData: null,
      loading: false
    };
  },
  watch: {
    go() {
      if (this.pv) {
        this.pv.scrollTo(this.goToPage, 1);
      }
    }
  },
  methods: {
    newPdfViewer() {
      if (this.pdfData && !this.pv) {
        this.pv = new PDFViewer({
          cmaps: './cmaps/',
          data: this.pdfData,
          container: this.$refs.pdfContainer,
          isRenderText: true,
          containerBackground: '#ffffff',
          gap: 0
        });
        this.addPdfReadyLinstener();
      } else if (!this.pdfData && !this.pv) {
        this.$message.error('pdf 错误');
      }
    },
    async getPdfData() {
      this.loading = true;
      try {
        let link = this.link.indexOf('?') === -1 ? this.link : this.link.replace(/\?/, '%3F');
        const res = await api.getPdfData(link);
        this.pdfData = res;
        this.newPdfViewer();
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        }
        this.loading = false;
      }
    },
    async showPdf() {
      await this.getPdfData();
      this.newPdfViewer();
    },
    addPdfReadyLinstener() {
      if (!this.pv) return;
      this.pv.addEventListener('load', () => {
        this.$emit('pdfInitReady');
      });
    }
  },
  mounted() {
    this.showPdf();
  },
  beforeDestroy() {
    if (this.pv) {
      this.pv.destroy();
    }
  }
};
</script>
    
<style lang="scss" scoped>
.pdf-container {
  width: 100%;
  height: 100%;
  .pdf-viewer {
    width: 100%;
    height: 100%;
  }
}
</style>
